/** Keep only reviewed public keys; never retain backend text or arguments in UI state. */
const KEYS = {
  'USER_PASSWORD_ERROR': 'credentials',
  'user.password.error': 'credentials',
  'username.not.exist': 'credentials',
  'login.data.error': 'credentials',
  'travel.grouptrip.invalid.lifecycle': 'travel.grouptrip.invalid.lifecycle',
  'member.disabled': 'disabled',
  'account.already.register': 'accountExists',
  'email.already.registered': 'emailExists',
  'phone.already.registered': 'phoneExists',
  'email.not.registered': 'emailMissing',
  'phone.not.registered': 'phoneMissing',
  'verification.code.not.exists': 'codeExpired',
  'verification.code.incorrect': 'codeIncorrect',
  'verify.code.send.too.frequent': 'tooFrequent',
  'too.many.requests': 'tooFrequent',
  'verify.code.send.failed': 'sendFailed',
  'tourists.disabled': 'touristsDisabled',
  'promotionCode.not.found': 'inviterInvalid',
};
const CODES = { 90001: 'credentials', 90004: 'credentials', 90015: 'accountExists', 90021: 'codeExpired', 90022: 'codeIncorrect', 90040: 'phoneExists', 90041: 'emailExists', 90042: 'phoneMissing', 90043: 'emailMissing', 90044: 'tooFrequent', 90045: 'sendFailed', 91074: 'touristsDisabled' };
export function captureAuthError(cause, fallbackKey) {
  const publicKey = Object.prototype.hasOwnProperty.call(KEYS, cause?.raw?.key)
    ? KEYS[cause.raw.key] : (!cause?.raw?.key && Object.prototype.hasOwnProperty.call(CODES, cause?.code ?? cause?.raw?.code) ? CODES[cause.code ?? cause.raw.code] : null);
  return { key: publicKey ? (publicKey.startsWith('travel.') ? publicKey : `authErrors.${publicKey}`) : fallbackKey };
}
export function renderAuthError(error, t) {
  if (!error) return '';
  const value = typeof error.key === 'string' ? t(error.key) : '';
  if (typeof value === 'string' && value && value !== error.key) return value;
  return t('authErrors.generic');
}
